// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React, { useEffect, useRef, useState } from 'react';
const AdaptiveText = ({ text, fontSizes, className = '', width = '100%', lineHeight = 1.2, fontUnit = 'rem', maxHeight = Infinity, maxLines = Infinity }) => {
    const containerRef = useRef(null);
    const [fontIndex, setFontIndex] = useState(0);
    useEffect(() => {
        const el = containerRef.current;
        if (isNullOrUndefined(el))
            return;
        const check = () => {
            var _a, _b;
            const parentHeight = maxHeight !== null && maxHeight !== void 0 ? maxHeight : (_a = el.parentElement) === null || _a === void 0 ? void 0 : _a.offsetHeight;
            let i = 0;
            while (i < fontSizes.length) {
                el.style.fontSize = `${fontSizes[i]}${fontUnit}`;
                // allow the browser to apply the style before measuring
                // or force a reflow (offsetHeight)
                void el.offsetHeight;
                const computedLineHeight = parseFloat((_b = getComputedStyle(el).lineHeight) !== null && _b !== void 0 ? _b : `${fontSizes[i] * lineHeight}`);
                const lines = Math.round(el.scrollHeight / computedLineHeight);
                const totalLineHeight = lines * computedLineHeight;
                const allowedLines = Math.min(i + 1, maxLines);
                if (lines <= allowedLines && totalLineHeight <= parentHeight)
                    break;
                i++;
            }
            setFontIndex(i >= fontSizes.length ? fontSizes.length - 1 : i);
        };
        check();
    }, [text, fontSizes, lineHeight, fontUnit, maxHeight, maxLines]);
    return (React.createElement("span", { ref: containerRef, className: `adaptive-text ${className}`, style: Object.assign(Object.assign({}, (fontIndex > 0 ? { width } : {})), { fontSize: `${fontSizes[fontIndex]}${fontUnit}`, lineHeight, WebkitLineClamp: Math.min(fontIndex + 1, maxLines !== null && maxLines !== void 0 ? maxLines : fontIndex + 1) }) }, text));
};
export default AdaptiveText;
